module.exports = __webpack_public_path__ + "img/main_logo.5fd098f983.png";